import './InfoCardBodyGrid.scss';
import React, { memo } from 'react';
import { AdjustableComponent } from '../../../../../utils/hooks/useClasses';
import { useClasses } from '../../../../../utils/hooks/useClasses';
import InfoCardBody, { InfoCardBodyProps } from './InfoCardBody';
import { GridItemType } from '../../../types';
import { PendingContent, Spinner } from 'plume-ui';
import uuid from 'react-uuid';
import { parseCriteriaSequence } from '../helpers';
import { useTranslation } from 'react-i18next';

type InfoCardBodyGridProps = {
  label: string;
  data: GridItemType[];
  bodyProps?: Partial<InfoCardBodyProps>;
  loading: boolean;
  unconfig?: boolean;
};

type InfoCardBodyGridStyles = {
  root: string;
  metricName: string;
  metricValue: string;
};

const InfoCardBodyGrid: AdjustableComponent<
  InfoCardBodyGridProps,
  InfoCardBodyGridStyles
> = ({ classes, data, label, bodyProps, loading, unconfig }) => {
  const { t } = useTranslation();

  const styles: InfoCardBodyGridStyles = useClasses(
    {
      root: 'MonitorInfo__info-card__grid',
      metricName: 'MonitorInfo__info-card__grid__name',
      metricValue: 'MonitorInfo__info-card__grid__value',
    },
    classes,
  );

  const isCriteriaSequence = (
    input: string | number | JSX.Element,
  ): boolean => {
    if (typeof input !== 'string') return false;
    return /AND|OR/.test(input);
  };

  return (
    <InfoCardBody
      {...bodyProps}
      label={label}
      showEdit={Boolean(bodyProps?.editRoute)}
    >
      {!loading && unconfig && (
        <div className="MonitorInfo__info-card__grid--unconfig">
          {t('monitors.monitorInfo.unconfigOutreach', {
            outreachType: label,
          })}
        </div>
      )}
      <PendingContent loading={loading} loader={Spinner}>
        <div className={styles.root}>
          {data.map((item) => (
            <React.Fragment key={uuid()}>
              <span className={styles.metricName}>{item.metric}</span>
              <span className={styles.metricValue}>
                {isCriteriaSequence(item.value)
                  ? parseCriteriaSequence(item.value as string)
                  : item.value}
              </span>
            </React.Fragment>
          ))}
        </div>
      </PendingContent>
    </InfoCardBody>
  );
};

export default memo(InfoCardBodyGrid);
